<template>
    <div>
        <div class="d-flex align-items-start">
            <div class="form-group me-2">
                <label>
                    <localized-text localizedKey="Margine inferiore" text="Margine inferiore"></localized-text>
                </label>
                <select class="form-control" v-model="localValue.marginBottom">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            <div class="form-group">
                <label>
                    <localized-text localizedKey="Larghezza completa" text="Larghezza completa"></localized-text>
                </label>
                <div>
                    <toggler :mini="true" v-model="localValue.isFullWidth"></toggler>
                </div>
            </div>
        </div>
        <component :is="componentType" v-model="localValue"></component>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { Options } from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import WithModel from '@/mixins/withModel';
import bluePaintBlock from './bluePaintBlock.vue';
import bulletPointsBlock from './bulletPointsBlock.vue';
import midTitleBlock from './midTitleBlock.vue';
import paragraphBlock from './paragraphBlock.vue';
import priceBlock from './priceBlock.vue';
import routerButtonBlock from './routerButtonBlock.vue';
import titleBlock from './titleBlock.vue';
import trapezioBlock from './trapezioBlock.vue';
import htmlTextBlock from './htmlTextBlock.vue';

@Options({
    components: {
    }
})
export default class baseHtmlBlock extends Mixins(WithModel) {

    declare localValue: OM.BaseHtmlBlock;

    get componentType(){
        if(this.localValue.type == "BluePaintBlock")
            return bluePaintBlock;
        else if(this.localValue.type == "BulletPointsBlock")
            return bulletPointsBlock;
        else if(this.localValue.type == "MidTitleBlock")
            return midTitleBlock;
        else if(this.localValue.type == "ParagraphBlock")
            return paragraphBlock;
        else if(this.localValue.type == "PriceBlock")
            return priceBlock;
        else if(this.localValue.type == "RouterButtonBlock")
            return routerButtonBlock;
        else if(this.localValue.type == "TitleBlock")
            return titleBlock;
        else if(this.localValue.type == "TrapezioBlock")
            return trapezioBlock;
        else if(this.localValue.type == "HtmlTextBlock")
            return htmlTextBlock;
        else
            return "";
    }

}
</script>
